export const links = [
  {
    url: 'http://www.saginawcounty.com/Coa/Default.aspx',
    name: 'Saginaw County - Commission on Aging',
  },
  {
    url: 'http://www.baycounty-mi.gov/aging/',
    name: 'Bay County - Division on Aging',
  },
  {
    url: 'http://www.alz.org/index.asp',
    name: 'Alzheimer’s Disease and Related Disorder Association',
  },
  {
    url: 'http://www.apdaparkinson.org/userND/index.asp',
    name: 'American Parkinson’s Disease Association',
  },
  {
    url: 'http://www.biusa.org/michigan',
    name: 'Michigan Brain Injury Association',
  },
  {
    url: 'http://www.nationalmssociety.org/index.aspx',
    name: 'National Multiple Sclerosis Society',
  },
  {
    url: 'http://www.braintumor.org/GeneralMenu/',
    name: 'National Brain Tumor Society',
  },
  {
    url: 'http://www.epilepsyfoundation.org/',
    name: 'National Epilepsy Foundation',
  },
  {
    url: 'http://www.stroke.org/site/PageNavigator/HOME',
    name: 'National Stroke Foundation',
  },
  {
    url: 'http://www.cdc.gov/concussion/index.html',
    name: 'CDC Concussion and Mild TBI',
  },
  {
    url: 'http://www.seniorservicesmidland.org/',
    name: 'Midland County Council on Aging',
  },
  {
    url: 'http://lighthouserehab.com/',
    name: 'The Lighthouse Neurological Rehabilitation Center',
  },
  {
    url: 'https://riversbendrehabilitation.com/',
    name: 'Riversbend Rehabilitation',
  },
  {
    url: 'http://americanbrainfoundation.org/',
    name: 'American Brain Foundation',
  },
]